import { createActionGroup, props } from '@ngrx/store';

export const successOnboardActions = createActionGroup({
  source: 'Success Onboard Page',
  events: {
    ['Load And Join Challenge']: props<{ challengeId: number }>(),
  },
});
